import React from "react"
import PropTypes from "prop-types"
import Grid from "@mui/material/Grid"
import CheckIcon from "@mui/icons-material/Check"
import CircleIcon from "@mui/icons-material/ChevronRight"

// A list of features with nice little checkmarks beside them.
// Inspired by Square.com.

const CheckmarkList = ({ items, showCheck, checkColor }) => (
  <Grid container spacing={2}>
    {items?.map((item, i) => (
      <Grid item key={i} xs={12} sm={6}>
        {showCheck ? (
          <CheckIcon
            style={{ marginBottom: -5, marginRight: 5 }}
            color={checkColor}
          />
        ) : (
          <CircleIcon
            style={{ marginBottom: -5, marginRight: 5 }}
            color={checkColor}
          />
        )}
        {item}
      </Grid>
    ))}
  </Grid>
)

CheckmarkList.propTypes = {
  items: PropTypes.array.isRequired,
  showCheck: PropTypes.bool,
  checkColor: PropTypes.string,
}

CheckmarkList.defaultProps = {
  showCheck: true,
  checkColor: "primary",
}

export default CheckmarkList
